import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { IGoogleMapsMarker } from "@interfaces/IGoogleMapsMarkerOptions";
import { GoogleMarkerService } from "@services/googleMarker.service";
import { VeriMarkerService } from "@services/veriMarker.service";
import * as angular from "angular";

interface IVeriMapPlotBindings {

    veriMap: IVeriMapComponent;
    location: google.maps.LatLngLiteral;

    label: string;
    icon: string;
}

class Controller implements angular.IComponentController, IVeriMapPlotBindings {
    veriMap: IVeriMapComponent;
    location: google.maps.LatLngLiteral;

    label: string;
    icon: string;

    marker: IGoogleMapsMarker;

    static $inject = ["veriMarkerService", "googleMarkerService"];

    constructor(
        private readonly veriMarkerService: VeriMarkerService,
        private readonly googleMarkerService: GoogleMarkerService) {
    }

    $onInit() { }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (onChangesObj["location"]) {
            this.veriMap.mapInitialisedPromise.then(() => {
                this.createMarker();
            });
        }
    }

    // ---------------------

    private createMarker() {
        const markerOptions = this.googleMarkerService.createEventMarkerOptions({
            label: this.label,
            markerClass: "marker-event-start",
            subIcon: this.icon || "place",
            showLabel: true,
            position: this.location
        });

        this.marker = {
            id: 1,
            options: markerOptions
        };

        this.veriMap.fitMap([new google.maps.LatLng(this.location)]);
        this.veriMap.getMap().setZoom(10);
    }
}

export class VeriMapLocationComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    require: { [index: string]: string; };

    constructor() {
        this.bindings = {
            location: "<",
            label: "@",
            icon: "@"
        };

        this.require = {
            veriMap: "^veriMap"
        };

        this.controller = Controller;
        this.template = require("./veriMapLocation.html");
    }
}
